import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getVerify, getIsVerified } from '../store/Auth.action';
import logo from '../../../assets/images/logo-bombyx-plm.jpg';
import './Signup.css';

function AccountConfirmation() {
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const { t } = useTranslation('common');
  const code = urlParams.get('code');
  const companyAdminEmail = urlParams.get('companyAdminEmail');
  const id = urlParams.get('id');
  const [state, setState] = useState('');
  const history = useHistory();

  useEffect(() => {
    const init = async () => {
      const data = {
        code,
        companyAdminEmail,
        id,
      };
      await dispatch(getIsVerified(id));
      const res = await dispatch(getVerify(data));
      if (res?.code === 200) {
        const message = res?.message ? t(`SIGNUP.${res?.message}`) : '';
        setState(message);
      } else {
        history.push('/login');
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, code, companyAdminEmail]);

  return (
    <div className="container">
      <section className="d-flex align-items-center justify-content-center">
        <div className="">
          <div className="portlet light">
            <div className="small_logo">
              <figure>
                <button type="button" onClick={() => history.push('/login')} className="focus:outline-none image-logo" aria-label="button">
                  <img src={logo} alt="Bombiix" />
                </button>
              </figure>
            </div>

            <div className="col-md-12 mt-2">
              <div className="portlet light">
                <div className="card-desc">
                  <div className="f-20 text-center text-bold">{state}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AccountConfirmation;
